import { useLocation } from 'react-router-dom';

/**
 * The path of the screen on display (I-1223), for `<main>`'s `data-route-location`.
 *
 * The router's location, not `window.location`: a move inside the app changes the address at the
 * click, and React Router applies the new location in a transition, so while the next route's code
 * is on its way the screen on display — and this value with it — is still the old one. A test that
 * waits for this to equal the address (`e2e/support/awaitView.ts`) waits for the screen the address
 * names, which a placeholder alone cannot tell it: a move draws none.
 */
export function useCommittedRouteLocation(): string {
  return useLocation().pathname;
}
